import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function Internet() {
  const blocks = useBlockRenderer('plans') as Block[]
  return <BlockRenderer blocks={blocks} />
}
